import { JWMButton } from "@components/JWMButton/JWMButton";
import { CountrySelector } from "@jmc/core/src/components/CountrySelector/CountrySelector";
import { BreakPoint, useMediaQuery } from "@jmc/solid-design-system/src/hooks/useMediaQuery/useMediaQuery";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
    countryList: {
        country_iso_code: string;
        country_name: string;
        website_url: string;
    }[];
    placement: string;
}

export const CountrySelectorBlock = ({ placement, countryList }: Props): JSX.Element => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery(BreakPoint.md);
    const { jnjFullBranded } = useJnjBranding();

    const parsedCountryList = countryList?.map((country) => {
        const button = (
            <JWMButton
                buttonProps={{ variant: "contained", color: "primary" }}
                text={t("Go to country site", { ns: "common" })}
                placement={placement}
                url={country?.website_url}
                external={true}
                size={jnjFullBranded ? "small" : "medium"}
                fullWidth={isMobile && jnjFullBranded}
            />
        );
        return { ...country, button };
    });

    return (
        countryList?.length && (
            <CountrySelector
                countries={parsedCountryList}
                countrySpecificText={t("Select a country to see country specific content", { ns: "common" })}
                placeHolderText={t("Select a Country ...", { ns: "common" })}
            />
        )
    );
};

export default CountrySelectorBlock;
